import React, {
  useEffect,
} from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  useSelector,
} from "react-redux";

import "./css/SuccessScreen.css";


function SuccessScreen() {

  const {
    restaurantId,
    tableId,
  } = useParams();


  const navigate =
    useNavigate();


  const location =
    useLocation();


  /*
  =======================================================
  RESTAURANT
  =======================================================
  */

  const themeState =
    useSelector(
      (state) =>
        state.theme || {}
    );


  const restaurantName =
    themeState.restaurantName ||
    themeState.restaurant_name ||
    "CYMA GREEK TAVERNA";


  /*
  =======================================================
  ORDER DATA
  =======================================================
  */

  const {
    orderId,
    paymentMethod,
    total,
  } =
    location.state || {};


  /*
  =======================================================
  PAYMENT LABEL
  =======================================================
  */

  const paymentLabel =
    paymentMethod === "ONLINE"
      ? "ONLINE PAYMENT"
      : "PAY AT TABLE";


  /*
  =======================================================
  RETURN TO MENU
  =======================================================
  */

  const handleReturnToMenu = () => {

    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  /*
  =======================================================
  AUTO REDIRECT
  =======================================================
  */

  useEffect(() => {

    const timer =
      setTimeout(() => {

        navigate(
          `/${restaurantId}/table/${tableId}`
        );

      }, 10000);


    return () => {

      clearTimeout(
        timer
      );

    };

  }, [
    navigate,
    restaurantId,
    tableId,
  ]);


  /*
  =======================================================
  SCREEN
  =======================================================
  */

  return (

    <main className="theme5-success-page">


      {/* =================================================
          TOP BLUE AREA
      ================================================= */}

      <section className="theme5-success-hero">

        <div className="theme5-success-container">


          <div className="theme5-success-eyebrow">

            ORDER CONFIRMED

          </div>


          <div className="theme5-success-mark">

            <span>
              ✓
            </span>

          </div>


          <h1>

            THANK
            <br />
            YOU.

          </h1>


          <p className="theme5-success-intro">

            Your order has been received
            and is now being prepared
            with care.

          </p>

        </div>

      </section>


      {/* =================================================
          DETAILS
      ================================================= */}

      <section className="theme5-success-content">

        <div className="theme5-success-container">


          <div className="theme5-success-layout">


            {/* =============================================
                ORDER CARD
            ============================================= */}

            <div className="theme5-success-card">


              <div className="theme5-success-card-heading">

                <span>
                  ORDER DETAILS
                </span>

                <strong>

                  #{orderId || "—"}

                </strong>

              </div>


              <div className="theme5-success-card-line" />


              <div className="theme5-success-detail-row">

                <span>
                  RESTAURANT
                </span>

                <strong>
                  {restaurantName}
                </strong>

              </div>


              <div className="theme5-success-detail-row">

                <span>
                  TABLE
                </span>

                <strong>
                  {tableId || "—"}
                </strong>

              </div>


              <div className="theme5-success-detail-row">

                <span>
                  PAYMENT
                </span>

                <strong>
                  {paymentLabel}
                </strong>

              </div>


              <div className="theme5-success-total">

                <span>
                  TOTAL
                </span>

                <strong>

                  ₹
                  {Number(
                    total || 0
                  ).toFixed(2)}

                </strong>

              </div>

            </div>


            {/* =============================================
                STATUS
            ============================================= */}

            <div className="theme5-success-status">


              <span className="theme5-success-status-label">

                STATUS

              </span>


              <h2>

                YOUR TABLE
                <br />
                AWAITS.

              </h2>


              <p>

                Our kitchen has received
                your order. Please relax,
                enjoy the atmosphere, and
                we'll take care of the rest.

              </p>


              <div className="theme5-success-status-line">

                <span>
                  ✓
                </span>

                ORDER RECEIVED

              </div>


              <div className="theme5-success-status-line theme5-success-status-pending">

                <span>
                  •
                </span>

                BEING PREPARED

              </div>


            </div>

          </div>


          {/* =================================================
              RETURN BUTTON
          ================================================= */}

          <div className="theme5-success-action">

            <button
              type="button"
              onClick={
                handleReturnToMenu
              }
            >

              RETURN TO MENU

              <span>
                →
              </span>

            </button>


            <p className="theme5-success-redirect">

              RETURNING TO MENU IN{" "}

              <strong>
                10
              </strong>

              {" "}SECONDS

            </p>

          </div>


          {/* =================================================
              BOTTOM MESSAGE
          ================================================= */}

          <div className="theme5-success-bottom">

            <span>
              OPA!
            </span>

            <p>

              Good food.
              Good friends.
              Good times.

            </p>

          </div>

        </div>

      </section>

    </main>

  );

}


export default SuccessScreen;